import type { AdminEvent, EventPayload } from '@/types/admin';

export function payloadFromEvent(event: AdminEvent): EventPayload {
  return {
    event_type: event.event_type,
    title: event.title,
    description: event.description ?? '',
    location: event.location ?? '',
    url: event.url ?? '',
    category: event.category_slug ?? event.category ?? '',
    tags: event.tags ?? '',
    month: event.month,
    day: event.day,
    year: event.year,
    start_date: event.start_date ?? '',
    end_date: event.end_date ?? '',
  };
}

export const EMPTY_PAYLOAD: EventPayload = {
  event_type: 'annual',
  title: '',
  description: '',
  location: '',
  url: '',
  category: '',
  tags: '',
  month: null,
  day: null,
  year: null,
  start_date: '',
  end_date: '',
};
